<script lang="ts">
    export let col: Column

    // A function to compare first names and sort the array
    const sortByFirstName = (a, b) => {
        const nameA = a.name.split(" ")[0] // Extracts the first name from "First Last"
        const nameB = b.name.split(" ")[0]
        return nameA.localeCompare(nameB)
    }

    col.boxList.boxes.sort(sortByFirstName) // Sorts the array in place
</script>

<div class="boxList">
    {#each col.boxList.boxes as name}
        <div class="box">
            {name.name}
        </div>
    {/each}
</div>

<style lang="less">
    @import "../../assets/css/main.less";

    .boxList {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        .box {
            padding: 5px 10px;
            background-color: @bg-color-secondary;
            color: @font-color-secondary;
            font-weight: bold;
        }
    }
</style>
